import {
  FETCH_AUDIENCE_PREVIEW,
  SET_AUDIENCE_TYPE,
  SET_INDUSTRY_ACTION,
  SET_ORGANISATION_ACTION,
  SET_HOME_ACTION,
  SET_DEMOGRAPHIC_ACTION,
  SET_LIFESTAGE_ACTION,
  SET_CONTENTGENRES_ACTION,
  SET_AUDIENCE_BUILDER_DATA_SOURCE,
  SET_AUDIENCE_DATE_RANGE,
  CREATE_AUDIENCE,
  DOWNLOAD_AUDIENCE_BUILDER,
  FETCH_INTEGRATIONS,
  SEND_AUDIENCE_INTEGRATION_JOB,
} from '../constants';

export const fetchAudiencePreview = (clientId) => ({
  type: FETCH_AUDIENCE_PREVIEW,
  clientId
});

export const setAudienceType = (typeName) => ({
  type: SET_AUDIENCE_TYPE,
  typeName
});

export const setIndustryAction = (data) => ({
  type: SET_INDUSTRY_ACTION,
  data
});

export const setDemographicAction = (data) => ({
  type: SET_DEMOGRAPHIC_ACTION,
  data
});

export const setLifeStageAction = (data) => ({
  type: SET_LIFESTAGE_ACTION,
  data
});

export const setContentGenresAction = (data) => ({
  type: SET_CONTENTGENRES_ACTION,
  data
});

export const setOrganisationAction= (data) => ({
  type: SET_ORGANISATION_ACTION,
  data
});


export const setHomeAction = (data) => ({
  type: SET_HOME_ACTION,
  data
});

export const setAudienceBuilderDataSoruce = (dataSource) => ({
  type: SET_AUDIENCE_BUILDER_DATA_SOURCE,
  dataSource
});

export const setAudienceDateRange = (since, until) => ({
  type: SET_AUDIENCE_DATE_RANGE,
  since,
  until
});

export const createAudience = (clientId) => ({
  type: CREATE_AUDIENCE,
  clientId
});

export const downloadAudienceBuilder = (data) => ({
  type: DOWNLOAD_AUDIENCE_BUILDER,
  payload: data
});

export const fetchIntegrations = (clientId) => ({
  type: FETCH_INTEGRATIONS,
  clientId
});

export const sendAudienceIntegrationJob = (data) => ({
  type: SEND_AUDIENCE_INTEGRATION_JOB,
  payload: data
});




